export const previewStyles = {
    MOBILE_PREVIEW: 'mobile-preview',
    DESKTOP_PREVIEW: 'desktop-preview',
    DEFAULT: 'default',
  };
